import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Header from "./components/header_bis";
import Hero from "./components/hero";
import NewsCarousel from "./components/actualites";
import Contact from "./components/contact";
import Support from "./components/supports";
import ActualitesPage from "./pages/ActualitesPage";
import DonOrganesPage from "./pages/DonOrganesPage";

function MainPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTop) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Header />
      <Hero />
      <div id="actualites" style={{ scrollMarginTop: '70px' }}>
        <NewsCarousel />
      </div>
      <Support />
      <Contact />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/actualites" element={<ActualitesPage />} />
        <Route path="/don-organes" element={<DonOrganesPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
